
export default {
  data() {
    return {
      isCalendlyActive: false,
      isDesktop: false,
      argument: {
        titleArgument: `Partagez votre <br class="hidden lg:block"> <span class="font-clash font-bold text-purple-brand">meilleure</span> image`,
        surtitle:
          "Une Identité visuelle unique avec l’agence de graphisme ALEO",
        webArguments: [
          {
            title: "Un logo personnalisé",
            text: "Obtenez un logo 100% personnalisé adapté à votre activité.",
            img: require("~/assets/img/picto-paint.svg"),
            alt: "Retour sur investissement",
          },
          {
            title: "Un graphiste dédié",
            text: "Bénéficiez du savoir-faire et de la créativité d'un graphiste dédié.",
            img: require("~/assets/img/picto-medal.svg"),
            alt: "Retour sur investissement",
          },
          {
            title: "Une identité de marque cohérente",
            text: "Construisez une identité visuelle cohérente sur l'ensemble de vos supports.",
            img: require("~/assets/img/picto-dots.svg"),
            alt: "Retour sur investissement",
          },
        ],
      },
      arguments2: [
        {
          img: "argument-graphism-1.png",
          title: "Renforcez l’image de votre entreprise",
          text: "Marquez vos clients et devenez reconnaissable au premier coup d'oeil.",
          alt: "Image de marque impactante",
        },
        {
          img: "argument-cm-2.png",
          title: "Rassurez et fidélisez vos clients",
          text: "Communiquez avec une image professionnelle et moderne.",
          alt: "Assurance et fidélisation",
        },
        {
          img: "argument-graphism-3.png",
          title: "Démarquez-vous de vos concurrents",
          text: "Sortez du lot grâce à une identité unique qui fera la différence.",
          alt: "Se démarquer de ses concurrents",
        },
      ],
      reviewCollab: {
        author: "Patrice - graphiste",
        text: "Je crée des logos uniques et mémorables",
        img: "patrice.png",
        alt: "Graphiste ALEO",
      },

      itemsList: [
        {
          title: "Prise de brief par un graphiste dédié",
          text: "Afin de créer un logo qui vous corresponde, définissez vos attentes et vos objectifs avec un expert ALEO.",
        },
        {
          title: "Création graphique",
          text: "Votre graphiste dédié vous proposera différentes pistes créatives pour que vous puissiez choisir celle qui vous convient le plus.",
        },
        {
          title: "Retouches et livraison",
          text: "Nous vous envoyons différentes propositions de logo et effectuons des retouches afin qu’il soit conforme à vos attentes.",
        },
      ],

      timeline: {
        surtitle: "Le design graphique chez Aleo",
        title: `Comment ça <span class="text-primary-500 font-clash font-bold">marche</span>&nbsp;?`,
        steps: [
          {
            img: "graphism-step-1.png",
            title: "Prise de brief",
            text: "Afin de créer une image qui vous ressemble, définissez vos objectifs et vos critères avec un expert ALEO.",
            alt: "Brief cartes de visite et logo",
          },
          {
            img: "cm-step-4.png",
            title: "Création de votre logo et de vos visuels",
            text: "2 pistes de logos vous sont proposées pour que vous puissiez choisir celle qui correspond le mieux à votre activité.",
            alt: "Création de logo",
          },
          {
            img: "graphism-step-3.png",
            title: "Validation de votre logo",
            text: "Nous effectuons des retouches sur la proposition que vous préférez pour que votre logo vous corresponde parfaitement.",
            alt: "Retouche design logo et carte de visite",
          },
          {
            img: "graphism-step-4.png",
            title: "Livraison des différents formats",
            text: "Avec votre nouveau logo, mettez-en plein la vue à vos clients (et futurs clients) !",
            alt: "Logo livrable en différents formats",
          },
        ],
      },

      reviews: [
        {
          text: "Ravie d’avoir travaillé et d’avoir fait confiance à l’agence ! J’ai un logo plus qu’au top, le personnel a été réactif à tout moment quant à la création des différentes choses que j’avais demandées !",
          author: "Institut Belle Demoiselle",
        },
        {
          text: "Très content de notre collaboration, La création de mon logo a déclenché la création de sacs et pleins d'autres goodies. J'ai pu grâce à ALEO, remoderniser mon identité visuelle, et mes clients adorent les cartes de visite.",
          author: "LE REPERE",
        },
        {
          text: "Très professionnel, très réactif, je recommande vivement à 100 % !",
          author: "CHAUFF'TAJ",
        },
      ],

      faq: [
        {
          question: "Quelles sont les étapes de la conception de mon logo ?",
          answer: `<p class="pb-4">La <strong>réalisation de votre logo</strong> par notre <strong>studio graphique</strong> débute par un entretien approfondi permettant de collecter les informations indispensables à la création de vos éléments graphiques. Cette compréhension précise de votre univers et de votre <strong>stratégie de communication</strong> nous permet ensuite de réaliser des <strong>maquettes de logos</strong> qui traduisent fidèlement votre identité d'entreprise.</p>
  <p>Suite à la réception des <strong>propositions de visuels</strong>, vous pouvez demander d'éventuelles modifications pour peaufiner le logo à votre image. Après validation, nous finalisons le design et vous envoyons votre logo <strong>sous différents formats</strong> par email. De la sorte, notre processus garantit un <strong>logo professionnel</strong>, sur-mesure et parfaitement en phase avec vos attentes.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Dois-je envisager une refonte de ma communication visuelle ?",
          answer: `<p class="pb-4">La <strong>refonte de votre communication visuelle</strong> peut s'avérer nécessaire et bénéfique. Dans un contexte en constante mutation, une identité visuelle actualisée aide à conserver la pertinence et l'attractivité de votre marque. Il est crucial que votre <strong>identité graphique</strong> représente votre entreprise telle qu'elle est aujourd'hui, et non comme elle était lors de sa fondation.</p>
  <p>Une <strong>agence de communication visuelle</strong> telle que la nôtre propose la création et la mise à jour d'identités graphiques. Que ce soit pour la création d'un nouveau logo, ou la modernisation de vos <strong>supports de communication</strong>, nous sommes en mesure de vous accompagner dans cette démarche. Cela contribuera à renforcer votre image de marque, améliorer votre visibilité et, par conséquent, <strong>attirer</strong> et <strong>fidéliser</strong> vos clients.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Pourquoi solliciter une agence de graphisme pour la création de son logo et de ses cartes de visite ?",
          answer: `<p class="pb-4">Solliciter une <strong>agence de communication</strong> spécialisée en <strong>création graphique</strong>, comme la nôtre, pour élaborer votre logo et vos cartes de visite est une démarche primordiale. En effet, ces éléments graphiques essentiels, conçus par des <strong>graphistes professionnels</strong>, sont les vecteurs de vos valeurs et vous démarquent de vos concurrents.</p>
  <p>Notre <strong>agence de graphisme</strong> garantit également une cohérence parfaite entre tous vos outils de communication, grâce à des chartes graphiques soigneusement établies. De ce fait, choisir notre <strong>studio de création graphique</strong> assure une direction artistique maîtrisée et une stratégie de communication graphique efficace, renforçant ainsi votre <strong>identité de marque</strong>.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "En quoi un studio de création graphique peut-il rehausser mon image ?",
          answer: `<p class="pb-4">Un <strong>studio de création graphique</strong>, comme le nôtre, joue un rôle déterminant dans l'évolution et le renforcement de votre image de marque. Il forge votre identité graphique, comprenant votre <strong>logo, votre charte graphique</strong> et votre <strong>univers visuel</strong>, ces éléments distinctifs qui différencient votre marque sur le marché.</p>
  <p>De plus, il assure une cohérence visuelle sur tous vos <strong>supports de communication</strong>, de votre site internet aux réseaux sociaux, améliorant ainsi votre visibilité et crédibilité. Grâce à la <strong>direction artistique et la communication visuelle</strong>, votre message et vos valeurs sont véhiculés de manière efficace, permettant de créer une expérience visuelle captivante pour vos clients.</p>`,
          isCollapsed: false,
        },
        {
          question: "Quels types de projets graphiques pouvez-vous réaliser ?",
          answer: `<p class="pb-4">L’agence ALEO s’occupe de la plupart des projets de création graphique des entrepreneurs. Nos experts s’occupent de la conception de <strong>logos</strong>, de <strong>cartes de visites</strong>, de <strong>plaquettes</strong>, de <strong>dépliants</strong> et de <strong>flyers</strong>. Tous les projets graphiques sont gérés par des graphistes experts dans leur domaine qui vous accompagneront au mieux pour vous faire ressortir aux yeux de vos clients. Pour toute autre demande, vous pouvez prendre rendez-vous avec un de nos experts afin d’obtenir un devis !</p>`,
          isCollapsed: false,
        },
        {
          question: "En combien de temps recevrais-je ma réalisation ?",
          answer: `<p class="pb-4">Nos experts s’engagent à vous livrer une première <strong>maquette</strong> 15 jours après la signature de votre contrat. Cette maquette sera à valider par vos soins pour que nous puissions effectuer différentes <strong>retouches</strong> afin que votre création vous convienne au mieux. En ce qui concerne les créations graphiques à imprimer, nous prenons en charge l’<strong>impression</strong> et la <strong>livraison</strong> de votre création. Les délais de livraison varieront en fonction de votre secteur géographique.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Quelle est la procédure à suivre pour commencer un projet de design graphique avec votre agence ?",
          answer: `<p class="pb-4">Lorsque vous décidez de passer par ALEO pour prendre en charge votre projet de création graphique, vous allez être contacté pour la mise en place de votre projet. Pendant cet appel, un conseiller vous posera différentes questions pour bien comprendre tous les contours de votre projet. Ce conseiller vous demandera par exemple les <strong>couleurs</strong> que vous souhaitez, votre <strong>slogan</strong>, la <strong>présentation de votre entreprise</strong>, les <strong>textes</strong> que vous souhaitez mettre en avant, etc.</p><p class="pb-4">Si vous n’avez pas d’idée précise concernant votre projet, nos équipes graphiques vous feront différentes propositions pour que vous puissiez avoir un aperçu des différentes possibilités.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Puis-je voir des exemples de projets graphiques que vous avez réalisés pour d'autres clients ?",
          answer: `<p class="pb-4">Oui, il est tout à fait possible de demander des exemples de projets graphiques réalisés pour d’autres clients. Cela nous aidera à vous proposer le <strong>design</strong> qui vous correspondra le mieux, et à vous faire une idée sur la qualité de nos <strong>créations</strong> ! Par exemple, les <a href="https://www.aleo.agency/blog/carte-de-visite-chauffagiste-tout-savoir-pour-la-reussir/" target="_blank">cartes de visites d'un chauffagiste</a> ou encore les <a href="https://www.aleo.agency/blog/pourquoi-et-comment-creer-votre-carte-de-visite-de-taxi/" target="_blank">cartes de visite d'un taxi</a>.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Pouvez-vous intégrer des éléments spécifiques dans mes projets graphiques ?",
          answer: `<p class="pb-4">Oui, nous pouvons parfaitement intégrer différents <strong>éléments spécifiques</strong> sur vos créations. Il vous faudra néanmoins veiller à nous les faire parvenir par mail et en bonne qualité pour avoir le meilleur rendu possible.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Comment se passe le support client après la livraison des fichiers graphiques ?",
          answer: `<p class="pb-4">Si vous êtes passés par ALEO pour la création de vos fichiers graphiques, nous nous tenons à votre disposition même après livraison, notamment si :</p><ul><li>Vous avez perdu votre <strong>création graphique</strong> ou souhaitez un autre format</li><li>Vous souhaitez une modification mineure sur votre <strong>logo</strong> (couleur, typo, etc).</li></ul><p class="pb-4">Pour tout autre type d’accompagnement, vous pourrez contacter directement le graphiste en charge de votre projet.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Est-ce que mes visuels seront optimisés pour être compatibles avec tous les supports (impression, web, mobile) ?",
          answer: `<p class="pb-4">Nous vous livrons différents formats pour optimiser la diffusion de votre support graphique : <strong>PNG</strong>, <strong>JPG</strong>, <strong>SVG</strong>, <strong>PDF</strong>. En fonction des demandes, nous pouvons vous livrer d’autres types de formats tels que le <strong>Webp</strong>. Nous vous livrerons le format adapté à l’action que vous souhaitez effectuer.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Offrez-vous des services de création de contenu visuel (illustrations, infographies, vidéos) en plus du design graphique ?",
          answer: `<p class="pb-4">Non, nous ne proposons pas de services de création de <strong>contenus visuels</strong> en plus des offres que nous proposons.</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Quels outils ou technologies utilisez-vous pour la création de vos designs graphiques ?",
          answer: `<p class="pb-4">Pour la création graphique, nos experts utilisent les outils professionnels de la <strong>suite Adobe</strong> (<strong>Photoshop</strong> et <strong>Illustrator</strong>).</p>`,
          isCollapsed: false,
        },
        {
          question:
            "Quels sont les avantages de choisir ALEO par rapport à d'autres agences de graphisme ?",
          answer: `<p class="pb-4"><a href="https://www.aleo.agency/blog/pourquoi-faire-appel-a-une-agence-de-graphisme/" target="_blank">Pourquoi choisir une agence de graphisme</a> comme ALEO ? Choisir ALEO pour la création de ses supports graphiques permet d’accéder au <strong>savoir-faire</strong> d’un graphiste professionnel, à votre écoute qui saura vous conseiller vers la meilleure création possible.</p>`,
          isCollapsed: false,
        },
      ],

      cases: [
        {
          author: "ERIC JURION - Gérant Le repère",
          text: "Ils ont été très réactifs et ont su me proposer ce qui correspondait exactement à mon besoin.",
          img: "case-studies/mockup-le-repere.jpg",
          link: "le-repere",
          alt: "Exemple de communication pret à porter",
        },
        {
          author: "FRÉDÉRIC MASSON - Gérant Masson Frères",
          text: "Une collaboration au top depuis plusieurs années ! Si vous êtes à la recherche d'une agence réactive, ALEO est celle qu'il vous faut. Des experts de la communication qui proposent des prestations toujours adaptées à mes besoins.",
          img: "impression-cards.jpg",
          link: "masson-freres",
          alt: "Cartes de visite Masson Frères",
        },
        {
          author: "ELSA DUBOIS - Gérante CMEG",
          text: "ALEO m'accompagne dans le développement de mon cabinet depuis plus d'un an. Leur professionnalisme et leur réactivité m'ont permis de démarrer sereinement mon activité. Je recommande à 100 %.",
          img: "case-studies/cmeg-sw.jpg",
          link: "cmeg",
          alt: "Projet client ALEO - Site internet",
        },
      ],

      price: {
        price: 400,
        text: "Marquez les esprits de vos clients dès maintenant.",
      },
    };
  },

  head() {
    return {
      title: "Agence de graphisme | Création d'identité visuelle | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Créez votre univers et développez votre image. Marquez l'esprit de vos clients avec des créations graphiques uniques grâce à ALEO, votre partenaire communication.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "ALEO, AGENCE DE GRAPHISME : CRÉATION D'IDENTITÉ VISUELLE",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Développez votre image et créez votre univers. Laissez une image stratosphérique dans l'esprit de vos clients avec des créations graphiques uniques !",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-graphisme.jpg"),
        // },
      ],
    };
  },

  mounted() {
    this.watchMedia();
    this.playVideo();
  },

  methods: {
    watchMedia() {
      window.matchMedia("(min-width: 1024px)").matches
        ? (this.isDesktop = true)
        : (this.isDesktop = false);

      if (this.isDesktop) {
        this.$refs.video.setAttribute(
          "poster",
          "/image/thumb-video-graphism.jpg"
        );
      } else {
        this.$refs.video.setAttribute(
          "poster",
          "/image/thumb-video-graphism-mobile.jpg"
        );
      }
    },

    activeCalendly() {
      this.isCalendlyActive = false;
      this.$nextTick(() => {
        this.isCalendlyActive = true;
      });
    },

    playVideo() {
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            if (this.isDesktop) {
              entry.target.src = require("~/assets/video/video-aleo-graphism.mp4");
            } else {
              entry.target.src = require("~/assets/video/video-aleo-graphism-mobile.mp4");
            }
            entry.target.play();
            io.unobserve(entry.target);
          }
        });
      });

      io.observe(this.$refs.video);
    },
  },
};
